<template>
	<el-dialog :visible="loginDialog" :show-close="false" top="280px" width="600px" center
		custom-class="login-dialog-radius">
		<div slot="title" class="login-dialog-title">
			登录
		</div>
		<div class="login-form">
			<el-form ref="loginForm" :model="loginForm" label-width="60px" :rules="loginRules">
				<div class="dialog-form">
					<el-form-item label="账号:" prop="account">
						<el-input type="text" v-model="loginForm.account" placeholder="手机号/用户名/邮箱"></el-input>
					</el-form-item>
					<el-form-item label="密码:" prop="password">
						<el-input type="password" v-model="loginForm.password" placeholder="密码"></el-input>
					</el-form-item>
					<el-form-item>
						<div class="dialog-link">
							<router-link to="forget">忘记密码？</router-link>
							<router-link to="register">注册账号</router-link>
						</div>
					</el-form-item>
					<el-form-item>
						<div class="dialog-button">
							<el-button type="warning" @click="closeLogin(2)">关闭</el-button>
							<el-button type="warning" :loading="loading" @click="doLogin('loginForm')">登录</el-button>
						</div>
					</el-form-item>
					<el-form-item>
						<div class="dialog-agreement">
							<el-checkbox v-model="checked"></el-checkbox>阅读并接受<router-link :to="{
								path:'/agreement',
								query:{
									id:'1961d643e0dc4c83b98b005eb7e8303b'
								}
							}">用户协议</router-link>及
							<router-link :to="{
								path:'/agreement',
								query:{
									id:'72beccc591c349528934ff34b832befb'
								}
							}">隐私政策</router-link>
						</div>
					</el-form-item>
				</div>
			</el-form>
		</div>
	</el-dialog>
</template>

<script>
	import {
		mapMutations
	} from 'vuex'
	export default {
		name: 'loginDialog',
		props: ['loginDialog'],
		data() {
			let verify_account = (rule, value, callback) => {
				if (this.loginForm.account == '') {
					callback(new Error('请输入账号'))
				} else {
					callback()
				}
			}
			let verify_password = (rule, value, callback) => {
				if (!this.$ver.verify_password(this.loginForm.password)) {
					callback(new Error('请输入6-18位密码'))
				} else {
					callback()
				}
			}
			return {
				loginForm: {
					account: '',
					password: ''
				},
				loginRules: {
					account: [{
						required: true,
						trigger: 'blur',
						validator: verify_account
					}],
					password: [{
						required: true,
						trigger: 'blur',
						validator: verify_password
					}]
				},
				checked: false,
				loading: false
			};
		},
		methods: {
			...mapMutations(['login', 'saveUserinfo']),
			doLogin(formName) {
				if (!this.checked) {
					this.$message({
						message: '请阅读《用户协议》与《隐私政策》后再继续。',
						type: 'error',
						duration: 2000
					})
					return
				}
				this.$refs[formName].validate((valid) => {
					if (valid) {
						this.loading = true
						this.$api.frontLogin({
							username: this.loginForm.account,
							pwd: this.loginForm.password
						}, res => {
							this.loading = false
							if (res.code == 200) {
								this.saveUserinfo(res.data.systemUser)
								this.login(res.data.token)
								let t = res.data.systemUser.authentication == 0 ? 1 : 3
								if (t == 3) {
									location.reload()
								}
								this.closeLogin(t)
							}
						})
					} else {
						console.log('error submit!!');
						return false;
					}
				});
			},
			closeLogin(t) {
				this.$emit('closeLogin', t)
			}
		},
		beforeCreate: function() {
			//生命周期 -- 组件实例刚被创建，组件属性计算之前，如DATA属性等
		},
		created: function() {
			//生命周期 -- 组件实例创建完成，属性已绑定，但DOM还未生成，$el属性还不存在
		},
		beforeMount: function() {
			//模板编译/挂载之前
		},
		mounted: function() {
			//模板编译/挂载之后
		},
		beforeUpdate: function() {
			//组件更新之前
		},
		updated: function() {
			//组件更新之后
		},
		activated: function() {
			// for keep-alive，组件被激活时调用
		},
		deactivated: function() {
			// for keep-alive，组件被移除时调用
		},
		beforeDestory: function() {
			// 组件销毁调用
		},
		destoryed: function() {
			// 组件销毁后调用
		}
	};
</script>

<style lang="less" scoped="scoped">
	.el-dialog {
		border-radius: @vue-border-radius-lg;
	}

	.dialog-form {
		width: 100%;
		padding: 0px @vue-spacing-row-lg;
		box-sizing: border-box;
	}

	.login-dialog-title {
		width: 100%;
		height: 70px;
		display: flex;
		justify-content: center;
		align-items: center;
		border-bottom: 2px solid orangered;
		font-size: @vue-font-size-base;
		font-weight: bold;
	}

	.dialog-link {
		width: 100%;
		display: flex;
		justify-content: space-between;

		a {
			color: @vue-text-color-active;
		}

		a:hover {
			color: @vue-text-color-red;
		}
	}

	.dialog-button,
	.dialog-agreement {
		width: 100%;
		display: flex;
		justify-content: center;
		padding-right: 60px;
		box-sizing: border-box;

		.el-button {
			width: 120px;
		}

		a {
			color: @vue-text-color-active;
			margin: 0px @vue-spacing-row-sm / 2;
		}

		a:hover {
			color: @vue-text-color-red;
		}

		.el-checkbox {
			margin-right: @vue-spacing-row-sm;
		}
	}
</style>
